import type { Quat, Vec3 } from '../contracts/scene-spec.js';

export const eulerXYZ = (x: number, y: number, z: number): Quat => {
  const c1 = Math.cos(x / 2);
  const c2 = Math.cos(y / 2);
  const c3 = Math.cos(z / 2);
  const s1 = Math.sin(x / 2);
  const s2 = Math.sin(y / 2);
  const s3 = Math.sin(z / 2);

  return [
    s1 * c2 * c3 + c1 * s2 * s3,
    c1 * s2 * c3 - s1 * c2 * s3,
    c1 * c2 * s3 + s1 * s2 * c3,
    c1 * c2 * c3 - s1 * s2 * s3,
  ];
};

export const radialDirection = (angle: number): Vec3 => [
  Math.cos(angle),
  Math.sin(angle),
  0,
];

export const isFiniteNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export const isFiniteVector = (
  value: unknown,
  length: 3 | 4,
): value is readonly number[] =>
  Array.isArray(value) &&
  value.length === length &&
  value.every(isFiniteNumber);

export const magnitude = (value: Vec3): number =>
  Math.hypot(value[0], value[1], value[2]);

